// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__3ORLJ","bigColWidth":"Table_bigColWidth__3fxhZ","biggerColWidth":"Table_biggerColWidth__S9R1D","row":"Table_row__3SDa0","col":"Table_col__2FXVo"};